import { SetWorkbookDataModel } from "../Models/Excel/SetWorkbookDataModel";
import { AddOrUpdateDocComment } from "../Models/DataWarehouse/AddOrUpdateDocComment";
import { DataWarehouseIndexGridModel } from "../Models/DataWarehouse/DataWarehouseIndexGridModel";
import { SetArticleSuggestionModel } from "../Models/DataWarehouse/ArticleSearch/SetArticleSuggestionModel";

export class DataWarehouseDataService {
    public static getDataWarehouseIndexModel(callback: (output: DataWarehouseIndexGridModel) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/datawarehouse/indexmodel`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }    
    
    // public static sentDocHeaderToErp(docHeaderId: string, docRevisionId: string, callback: (output: boolean) => void, error?: () => void) {
    //     $.ajax({
    //         type: 'POST',
    //         url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/senttoerp`,
    //         cache: false,
    //         contentType: "application/json",
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json'
    //         },
    //         dataType: "json",
    //         success: callback,
    //         error: () => {
    //             error && error();
    //         }
    //     });
    // }

    public static deleteDocDetailImpaCode(docDetailId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/datawarehouse/line/${docDetailId}/impa`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static deleteDocDetailSelectedArticleCode(docDetailId: string, callback: (output: any) => void, error?: () => void) {
        $.ajax({
            type: 'DELETE',
            url: `/api/company/datawarehouse/line/${docDetailId}/selectedarticlecode`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static setDocDetailSelectedArticle(docDetailId: string, articleSuggestionId:any, callback: (output: any) => void, error?: () => void) {
        var model = new SetArticleSuggestionModel();
        model.ArticleSuggestionId = `${articleSuggestionId}`;

        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/line/${docDetailId}/setarticlesuggestion`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(model),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }



    //#region Comments

    public static addOrUpdateComment(docHeaderId: string, docRevisionId: string, model : AddOrUpdateDocComment, callback: (output: string) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/addorupdatecomment`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            data: JSON.stringify(model),
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static deleteComment(docHeaderId: string, docRevisionId: string, commentId:string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/comment/${commentId}/delete`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static markDocHeaderAsQuoted(docHeaderId: string, callback: (output: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/${docHeaderId}/markasquoted`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    //#endregion

    //#region Attachments

    public static uploadProcureShipAttachment(docHeaderId: string, docRevisionId: string, formData : FormData, callback: (output: string) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/uploadprocureshipattachment`,
            cache: false,
            data : formData,
            contentType: false,
            enctype: 'multipart/form-data',
            processData: false,
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static deleteProcureShipAttachment(docHeaderId: string, docRevisionId: string, attachmentId:string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/procureship/attachment/${attachmentId}/delete`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }


    public static canSendToRevisionToErp(docHeaderId: string, docRevisionId: string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/cansendtoerp`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static canOfferRevisionToRobot(docHeaderId: string, docRevisionId: string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'GET',
            url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/canoffertorobot`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    //#endregion

    public static addDocDetailSuggestionAndSelect(docDetailId: string, articleId: string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/${docDetailId}/article/${articleId}/addandselect`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }

    public static clearAllSelectedArticleMatchesForLines(docHeaderId: string, docRevisionId: string, callback: (result: boolean) => void, error?: () => void) {
        $.ajax({
            type: 'POST',
            url: `/api/company/datawarehouse/${docHeaderId}/revision/${docRevisionId}/clearallselectedarticlematchesforlines`,
            cache: false,
            contentType: "application/json",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            dataType: "json",
            success: callback,
            error: () => {
                error && error();
            }
        });
    }
}